import { useContext } from "react";
import { getSubscriptionTagsByCategory } from "./getSubscriptionsByCategory";
import { SubscriptionsContext } from "./subscriptionsContext";

function useSubscriptions() {
  const { selectedPub, setSelectedPub } = useContext(SubscriptionsContext);
  const { modalShow, setModalShow } = useContext(SubscriptionsContext);
  const { selectedSubscriptionTags, setSelectedSubscriptionTags = () => {} } = useContext(SubscriptionsContext);
  const { subscriptionName, setSubscriptionName } = useContext(SubscriptionsContext);
  const { isSubscriptionFromPillsBar, setIsSubscriptionFromPillsBar } = useContext(SubscriptionsContext);
  const { selectedLanguages = [], setSelectedLanguages = () => {} } = useContext(SubscriptionsContext);
  const { pendingSubscribePubId, setPendingSubscribePubId } = useContext(SubscriptionsContext);

  const subscriptionTagsByCategory = getSubscriptionTagsByCategory(selectedPub);
  const defaultCategoriesAndTags = Object.entries(subscriptionTagsByCategory);

  return {
    selectedSubscriptionTags,
    setSelectedSubscriptionTags,
    defaultCategoriesAndTags,
    subscriptionTagsByCategory,
    selectedPub,
    setSelectedPub,
    modalShow,
    setModalShow,
    subscriptionName,
    setSubscriptionName,
    isSubscriptionFromPillsBar,
    setIsSubscriptionFromPillsBar,
    selectedLanguages,
    setSelectedLanguages,
    pendingSubscribePubId,
    setPendingSubscribePubId,
  };
}

export default useSubscriptions;
